import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "pane"]

  connect() {
    if (this.tabTargets.length > 0) {
      this.activateTab(this.tabTargets[0])
    }
  }

  switch(event) {
    event.preventDefault()
    this.activateTab(event.currentTarget)
  }

  activateTab(tab) {
    const tabIndex = tab.dataset.tabIndex

    this.tabTargets.forEach((el) => {
      el.classList.toggle("active", el === tab)
    })

    this.paneTargets.forEach((el) => {
      el.classList.toggle("hidden", el.dataset.tabIndex !== tabIndex)
    })
  }
}